// Public SMS program details. Keep the shop's existing phone/SMS links in site.ts.
export const smsProgram = {
  name: 'East End Automotive Repair Customer Care',
  legalName: 'East End Automotive Repair, LLC',
  sender: '(865) 999-0203',
  senderE164: '+18659990203',
  consentVersion: '2026-09-21',
  updatedLabel: 'September 21, 2026',
  privacyPath: '/privacy-policy',
  termsPath: '/sms-terms',
  contactPath: '/contact',
  // Policy references only; the contact page is not an SMS opt-in form.
  proofUrls: {
    contact: 'https://eear.websiteforge.net/contact',
    privacy: 'https://eear.websiteforge.net/privacy-policy',
    terms: 'https://eear.websiteforge.net/sms-terms',
  },
}
